const viewTemplate = `
<h3>{{=it.title}}</h3>
<div>{{=it.createBy}}&nbsp;&nbsp;&nbsp;&nbsp;{{=it.createTime}}</div>
<hr/>
{{? it.type == 4}}
    {{~it.attachmentList:attObject:index}}
        <div><video width="100%" controls src="{{=attObject.file_path}}"/></div>
    {{~}}
{{?}}

<div>{{=it.content}}</div>

{{? it.type == 2}}
    {{~it.attachmentList:attObject:index}}
        <div><img width="100%" src="{{=attObject.file_path}}"/></div>
    {{~}}
{{?}}

<div style="height: 16px">&nbsp;</div>
<div class="relative-news">
    <div class="hr"></div>
    <div class="label">холбогдох мэдээлэл</div>
    <div class="hr"></div>
</div>

{{~it.relatedNews:newsObject:index}}
    {{? index > 0}}<hr height="8"/>{{?}}
    <a href="{{=it.baseUrl}}{{=newsObject.newsId}}">
        <div class="news-item">
            <div class="item-img"><img src="{{=newsObject.thumbImage}}"/></div>
            <div class="item-title">{{=newsObject.title}}</div>
        </div>
    </a>
{{~}}
`;

const contentUrl = "https://xinhua.5mus.com/static/h5/index.html?newsId=";
// const newsApiUrl = "https://xinhua.5mus.com/news_api/news/newsDetail?newsId=";
const newsApiUrl = "https://xinhua.5mus.com/news_api/news/newsV2Detail?newsId=";

(async () => {
    let params = GetUrlParam();
    let newsId = params["newsId"];
    await getContent(newsId)
})();



async function getContent(newsId) {
    const url = `${newsApiUrl}${newsId}`;
    const config = {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    }

    try {
        const resp = await fetch(url, config);
        const pro = await resp.text();
        const json = JSON.parse(pro);
        const newsDetail = json["data"]["newsDetail"]

        newsDetail['baseUrl'] = contentUrl;
        var attachmentList = newsDetail["attachmentList"];
        if (newsDetail["type"] == 4) {
            var tmpList = []
            for (var i = 0; i < attachmentList.length; i++) {
                if (attachmentList[i]['file_type'] == 2) {
                    tmpList.push(attachmentList[i])
                }
            }
            newsDetail["attachmentList"] = tmpList;
        } else {
            var tmpList = []
            for (var i = 0; i < attachmentList.length; i++) {
                if (attachmentList[i]['file_type'] == 0) {
                    tmpList.push(attachmentList[i])
                }
            }
            newsDetail["attachmentList"] = tmpList;
        }

        var content = newsDetail["content"];
        // console.log(content);
        // content = content.replace(/<img.*?>/g, "");
        // console.log('##################### after ###################');
        // console.log(content);
        newsDetail["content"] = content;

        var relatedNews = json["data"]["relatedV2News"];

        for (var i = 0; i < relatedNews.length; i++) {
            relatedNews[i]["thumbImage"] = relatedNews[i]["filePath"];
            // var relatedAttachmentList = relatedNews[i]["attachmentList"];
            // for (var j = 0; j < relatedAttachmentList.length; j++) {
            //     if (relatedAttachmentList[j]["file_type"] == 4) {
            //         relatedNews[i]["thumbImage"] = relatedAttachmentList[j]["file_path"];
            //         break;
            //     }
            // }
            if (!relatedNews[i]["thumbImage"]) {
                relatedNews[i]["thumbImage"] = "http://xinhua.5mus.com/profile/upload/images/2023/03/27/444a5b6558a313047c1b6aad841a8831.png";
            }
        }

        newsDetail['relatedNews'] = relatedNews;

        const tempFn = require('dot').template(viewTemplate);
        var resultText = tempFn(newsDetail);
        document.getElementById("content").innerHTML = resultText;
        // console.log(resultText);
    } catch (err) {
        console.log(err);
    }
}

function GetUrlParam() {
    let url = document.location.toString();
    let arrObj = url.split("?");
    let params = Object.create(null)
    if (arrObj.length > 1) {
        arrObj = arrObj[1].split("&");
        arrObj.forEach(item => {
            item = item.split("=");
            params[item[0]] = item[1]
        })
    }
    return params;
}
